import React from "react";

import { Link } from "react-router-dom";
import { housesData } from "../data";
import { MdOutlineWaves } from "react-icons/md";
import { RiArrowRightLine, RiMapPin2Fill, RiSparkling2Line } from "react-icons/ri";

const Banner = () => {
    const featuredHouse = housesData[0];

    return (
        <section className="relative min-h-[680px] overflow-hidden">
            <div
                className="absolute inset-0 scale-105 bg-cover bg-center hero-pan"
                style={{ backgroundImage: `url(${featuredHouse.imageLg || featuredHouse.image})` }}
                aria-hidden="true"
            />
            <div className="hero-overlay absolute inset-0" aria-hidden="true" />
            <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-[#f6f1e8] to-transparent" aria-hidden="true" />

            <div className="container relative z-10 mx-auto flex min-h-[680px] flex-col justify-end px-4 pb-10 pt-20 md:justify-center md:pb-16">
                <div className="max-w-3xl animate-fade-up">
                    <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/15 px-4 py-2 text-sm font-semibold text-white shadow-xl backdrop-blur-md">
                        <RiSparkling2Line className="text-[#f7c45f]" />
                        Premium weekly shore rental
                    </div>
                    <h1 className="max-w-3xl text-4xl font-bold leading-[1.04] tracking-tight text-white sm:text-5xl md:text-7xl">
                        Stay steps from the beach and bay.
                    </h1>
                    <p className="mt-6 max-w-2xl text-lg leading-8 text-white/80 md:text-xl">
                        A polished Lavallette home base with room for family, friends, beach gear, sunset walks, and easy weeks at the shore.
                    </p>
                    <div className="mt-7 flex flex-wrap gap-3 text-sm font-semibold text-white/90">
                        <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-2 backdrop-blur-md">
                            <RiMapPin2Fill className="text-[#f7c45f]" />
                            35 W Brighton Ave
                        </span>
                        <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-2 backdrop-blur-md">
                            <MdOutlineWaves className="text-[#f7c45f]" />
                            Beach, bay, dining nearby
                        </span>
                    </div>
                    <Link
                        to={`/property/${featuredHouse.id}`}
                        className="mt-8 inline-flex items-center gap-3 rounded-xl bg-white px-6 py-4 text-base font-bold text-slate-950 shadow-2xl shadow-slate-950/25 transition duration-300 hover:-translate-y-0.5 hover:bg-[#f7c45f] focus:outline-none focus:ring-4 focus:ring-white/40"
                    >
                        View this property
                        <RiArrowRightLine className="text-xl" />
                    </Link>
                </div>
            </div>
        </section>
    )
}

export default Banner;
